export default __webpack_public_path__ + "static/media/nav_logo_white_border.294937b5.png";